import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(({ palette, spacing }) => ({
  list_item: {
    padding: spacing(1, 2),
  },

  "list_item--active": {
    "& .MuiTypography-root": {
      color: palette.primary.main,
    },
    "& svg": {
      color: palette.primary.main,
    },
    "&:hover": {
      backgroundColor: palette.primary.light,
    },
    backgroundColor: palette.primary.light,
  },
  list_item__badge: {
    "& span": {
      backgroundColor: palette.success.main!,
    },
  },
  list_item__icon: {
    color: palette.grey["600"],
    marginLeft: spacing(0.5),
    marginRight: spacing(2.5),
    minWidth: spacing(3),
  },
  list_item__icon__tooltip: {
    marginLeft: 0,
  },
  list_item__text: {
    margin: 0,
    whiteSpace: "nowrap",
  },
  list_item__text__typo: {
    color: palette.grey["600"],
    fontSize: 15,
    fontWeight: 450,
  },
}));
